import React from 'react';
import { cx } from '../cx';

// 앱 타일 — 원형 아이콘 + 라벨 세로 배치 (D-07 §3.2 #20 예외로 승인된 신규 컴포넌트, 2026-10-22 승인).
// 공유 앱 선택(카카오톡 등)처럼 "아이콘을 눌러 해당 앱으로 보내는" 단일 동작 버튼에 쓴다.
// 네이티브 button — Enter/Space·tabIndex·disabled 기본 지원, :focus-visible 2px 포커스 링.
// tone="kakao" 는 브랜드 색(--brand-kakao-container/-symbol)만 쓰는 예외 — 다른 브랜드 톤은 두지 않는다.
// 손 작성 컴포넌트 — 계약 ui-theme/contracts/apptile.contract.json(draft)은 규격 기록용, 생성기 에미터 없음 — 클래스는 styles/components.css(.app-tile).
export interface AppTileProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** 아이콘 슬롯 — currentColor svg (예: IconKakaoTalk). 크기는 호출부가 24 로 지정 */
  icon: React.ReactNode;
  /** 아래 라벨 */
  label: React.ReactNode;
  /** default 회색 칩 · kakao 카카오 브랜드색 칩 */
  tone?: 'default' | 'kakao';
}

export const AppTile = React.forwardRef<HTMLButtonElement, AppTileProps>(function AppTile(
  { icon, label, tone = 'default', className = '', type = 'button', ...props },
  ref,
) {
  return (
    <button ref={ref} className={cx('app-tile', tone !== 'default' && `app-tile-${tone}`, className)} {...props} type={type}>
      <span className="app-tile-icon" aria-hidden="true">{icon}</span>
      <span className="app-tile-label">{label}</span>
    </button>
  );
});
